import { useEffect, useRef } from 'react';

export const useModalDialog = (triggerState: unknown, onClose: () => void) => {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;

    if (triggerState) {
      dialog.showModal();
    }

    const handleClose = () => onClose();
    dialog.addEventListener('close', handleClose);
    return () => dialog.removeEventListener('close', handleClose);
  }, [triggerState, onClose]);

  return {
    ref,
    show: () => ref.current?.showModal(),
    close: () => ref.current?.close(),
  };
};
